import axios from "axios";
import { Ref } from "vue";
import { useRoute, useRouter } from "vue-router";

function withRetry<T>(fn: () => Promise<T>, retries: number = 3) {
    return fn().catch((e) => {
        if (retries > 0) {
            return withRetry(fn, retries - 1);
        }
        throw e;
    });
}

export  function usePatientPostalCode(pid: Ref<string>) {
    const route = useRoute();
    const router = useRouter();
    
    const getPostalCodeFromServer = async () => {
        try {
            const res = await withRetry(() => axios.post('/getPatientPostalCode', {
                pid: pid.value
            }) as any);
            
            if (res.status == 'success') {
                router.replace({ query: { ...route.query, postalCode: res.data.postalCode.replaceAll(' ', '') } });
            }
        } catch (e) {
            console.error(e);
        }
    }

    return {
        getPostalCodeFromServer
    }
}